import { useContext } from 'react';
import { MenuContext } from '../../providers/MenuProvider';

export default function useMenu() {
  return useContext(MenuContext);
}
